export const TRANSLATIONS_PT = {
  All: "Todos",
  Dry: "Seco",
  Dryingout: "A secar",
  Healthy: "Saudável",
  Manual: "Manual do utilizador",
  Menu: "Menu",
  Midphase: "Fase de maturidade",
  Oldphase: "Fase de envelhecimento",
  Profile: "Perfil",
  Set_the_report_of_the_project_with_the_help_of_the_pin:
    "Configure o relatório do projeto com a ajuda do pino",
  Settings: "Definições",
  Unknown: "Desconhecido",
  Wet: "Demasiado húmido",
  Youngphase: "Fase juvenil",
  account_type: "Tipo de conta",
  action: "Medida",
  action_priority: "Ações prioritárias",
  action_required: "Ações necessárias",
  actions: "Ações",
  active: "ativo",
  active_installation: "Instalação ativa",
  active_sensor_installation: "Instalação ativa de sensores",
  add: "Adicionar",
  addTree: "Adicionar árvore",
  add_all_form: {
    area: {
      existing_area: "Selecionar localização existente",
      explanation:
        "Aqui pode ser criada uma nova localização ou selecionar uma já existente, à qual a árvore será adicionada.",
      new_area: "Criar nova localização",
      title: "Localização",
    },
    no_photos: "Não foram carregadas fotos",
    sensor: {
      existing_sensors: "Adicionar sensores existentes",
      explanation:
        "Aqui pode ser criado um novo sensor e adicionado à árvore. Ou pode ser selecionado um sensor já existente para adicionar à mesma.",
      new_sensor: "Criar novo sensor",
      title: "Sensor",
    },
    title: "Adicionar árvore com sensor à área",
    traffic_safety: "Segurança",
    tree: {
      existing_tree: "Selecionar árvore existente",
      explanation: "Aqui pode ser criada uma nova árvore ou selecionar uma existente.",
      new_tree: "Criar nova árvore",
      title: "Árvore",
    },
    tree_info: "Informação sobre a árvore",
  },
  add_area: "Criar localização",
  add_assessment: "Adicionar verificação",
  add_child_tree: "Adicionar árvore subordinada",
  add_comment: "Adicionar comentário",
  add_existing_tree: "Adicionar árvore existente",
  add_inspection: "Adicionar controlo",
  add_installation: "Criar instalação",
  add_photo: "Adicionar foto",
  add_safety_assessment: "Adicionar verificação de segurança",
  add_sensor: "Adicionar sensor",
  add_task: "Adicionar tarefa",
  add_tree_img: "Carregar imagens da árvore",
  add_user: "Adicionar utilizador",
  add_vta: "Adicionar VTA",
  add_your_own_maintenance: "Adicionar manutenção própria",
  address: "Endereço",
  adjust_thresholds_crown: "Ajustar limites para o índice de humidade Pulse",
  adjust_thresholds_soil: "Ajustar limites para sensores do solo",
  admin: "Admin",
  aim: "Objetivo do projeto",
  aim_irrigation_demand_determination: "Determinação da exigência de rega",
  alerts: "Alarmes",
  align_qr_code_within_the_frame: "Alinhar código QR dentro da moldura",
  all_areas: "Todas as localizações",
  all_projects: "Todos os projetos",
  all_responsible: "Todos os responsáveis",
  all_species: "Todas as espécies de árvores",
  all_trees: "Todas as árvores",
  already_have_an_account: "Já tem uma conta?",
  altitude: "Altitude",
  amount_nodes: "Número de pontos de sensor",
  api_documentation: "Documentação da API",
  appearance: "Aparência",
  area: "Localização",
  areaName: "Nome",
  area_form: {
    existing_area: "Localização existente",
  },
  area_management: "Gestão de localizações",
  areas: "Localizações",
  assessment_date: "Data de avaliação",
  assessor: "Perito",
  assign_to_tree: "atribuir à árvore",
  back: "Voltar",
  back_to_login: "Voltar ao início de sessão",
  activate_account: "Ativar conta",
  activating_account: "Ativando sua conta...",
  activation_success: "Conta ativada com sucesso!",
  activation_success_message: "Sua conta foi ativada com sucesso. Agora você pode fazer login.",
  activation_failed: "Falha na ativação",
  bark_condition: {
    healthy: "Saudável",
    minor_damage: "Danos ligeiros",
    moderate_damage: "Danos moderados",
    severe_damage: "Danos graves",
  },
  bark_condition_label: "Estado da casca",
  basic: "Básico",
  basic_user_areas_hint:
    "Os utilizadores básicos devem ser atribuídos a uma ou mais localizações. Sem atribuições, o seu acesso a dados é limitado.",
  basic_user_projects_hint:
    "Aqui podem ser atribuídos projetos completos. Todas as localizações/áreas associadas dos projetos escolhidos serão assumidas.",
  battery: "Bateria",
  battery_empty: "Bateria vazia",
  battery_full: "Bateria cheia",
  battery_is_getting_low: "A bateria está a ficar fraca",
  beta_ended: {
    description:
      "Obrigado por utilizar a versão beta! Todas as alterações e melhorias da fase beta foram incorporadas e estão agora disponíveis na TreeSense Cloud.",
    link_text: "Ir para TreeSense Cloud",
    subtitle: "A fase de teste terminou",
    title: "Fase beta terminada",
  },
  button: {
    add_all: "Criar árvore com sensor",
    add_customer: "Adicionar cliente",
    add_irrigation_area: "Adicionar área de rega",
    add_sensor: "Adicionar sensor",
    add_tree: "Adicionar árvore",
    back: "Voltar",
    cancel: "Cancelar",
    edit_customer: "Editar cliente",
    import_tree: "Importar árvore",
    next: "Seguinte",
    reset: "Repor",
    save: "Guardar",
    saving: "A guardar ...",
    update: "Atualizar",
    updating: "A atualizar ...",
  },
  calculated_values_wip:
    "Os valores calculados (moisture_content, resis_temp_comp) estão atualmente a ser ajustados e geralmente não devem ser entendidos como valores de medição, mas como auxílio à interpretação.",
  calibration_species: "Tipo de calibração",
  calibration_species_legacy_settings_hint:
    "Está a ser utilizada a calibração antiga do choupo-negro.",
  calibration_species_no_mapping: "Sem mapeamento de espécie de árvore disponível",
  calibration_species_settings_hint:
    "Se não for exibido nenhum mapeamento aqui ou se a fórmula antiga ainda estiver ativa, isto pode ser atualizado em Definições > Cliente > Fórmula de teor de humidade.",
  calibration_species_settings_link: "Ir para definições",
  calibration_species_tooltip:
    "Modelo de calibração utilizado a esta espécie para calcular o índice de humidade",
  calibration_species_unknown_tree_species: "Espécie de árvore em falta",
  cancel: "Cancelar",
  card_name: "Nome do cartão",
  card_number: "Número do cartão",
  care_chat: {
    action_required: "Necessidade de ação",
    add_entry: "Adicionar entrada",
    add_photo: "Adicionar foto",
    all_priorities: "Todas as prioridades",
    all_statuses: "Todos os estados",
    all_types: "Todos os tipos",
    amount: "Quantidade:",
    appointment_label: "Data:",
    assignment: "Atribuição",
    assignment_display: "Atribuição:",
    attachment_display: "Anexo:",
    back: "Voltar",
    cancel: "Cancelar",
    completion: "Conclusão",
    consult_specialist: "Coordenação com departamento especializado",
    cost_center: "Atribuição de custos",
    cost_center_display: "Atribuição de custos:",
    cut_type: "Tipo de poda:",
    date: "Data",
    datetime: "Data e hora",
    datetime_display: "Data / Hora:",
    deadline: "Prazo:",
    delete: "Eliminar",
    description: "Descrição",
    description_display: "Descrição:",
    detailed_investigation: "Exames detalhados",
    edit: "Editar",
    executor: "Executante:",
    favorite: "Favorito",
    felling: "Abate",
    fill_checklist: "Preencher lista de verificação",
    fill_form: "Preencher formulário",
    fill_protocol: "Preencher protocolo",
    finding: "Constatação:",
    follow_up_inspection: "Controlo regular (data de seguimento)",
    further_action_title: "Procedimento adicional",
    future_date_required: "Por favor, selecione uma futura data e hora.",
    immediately: "imediatamente",
    in_days: "Em {{days}} dias",
    in_hours: "Em {{hours}} horas",
    in_one_month: "Daqui a um mês",
    in_one_week: "Daqui a uma semana",
    inspected_by: "Controlado por",
    inspected_by_display: "Controlado por:",
    inspection_data: "Dados de controlo",
    inspection_date_display: "Data de controlo:",
    inspection_intervals: "Intervalos de controlo",
    inspection_level: "Nível de controlo:",
    inspection_title: "Documentar controlo regular",
    interval_as_before: "como antes",
    interval_display: "Intervalo:",
    interval_future_every: "no futuro, todas ",
    interval_years: "Intervalo (anos)",
    interval_years_annual: "anos / anualmente",
    irrigation_log_title: "Protocolo de rega",
    irrigation_method: "Método de rega",
    irrigation_method_display: "Método de rega:",
    irrigation_method_placeholder: "p. ex., manual, saco de rega, carro-cisterna",
    irrigation_protocol_title: "Preencher protocolo de rega",
    mark_done: "Marcar como concluído",
    mark_not_done: "Marcar como não concluído",
    measure_free: "Registo livre",
    measure_inspection: "Controlo regular",
    measure_irrigation: "Rega",
    measure_pruning: "Medida de poda",
    method: "Método:",
    next_inspection: "Próximo controlo",
    next_inspection_display: "Próximo controlo:",
    next_inspection_label: "Próximo controlo:",
    no: "Não",
    no_entries_found: "Não foram registos encontrados.",
    no_inspection_planned: "Sem controlo planeado.",
    no_tasks_found: "Sem tarefas encontradas.",
    overdue_since_days: "Atrasado à {{days}} dias",
    overdue_since_hours: "Atrasado à {{hours}} horas",
    perform_inspection: "Realizar controlo",
    plan_inspection: "Planear controlo",
    please_provide_tree_condition: "Por favor, indique o estado da árvore.",
    please_provide_type: "Por favor, indique o tipo.",
    please_select_person: "Por favor, selecione uma pessoa.",
    priority: "Prioridade",
    priority_critical: "Crítica",
    priority_high: "Alta",
    priority_low: "Baixa",
    priority_medium: "Média",
    pruning_clearing: "Limpeza / corte livre",
    pruning_crown_reduction: "Redução da copa / Cuidado da copa",
    pruning_formative: "Poda de formação",
    pruning_log_title: "Protocolo de poda",
    pruning_maintenance: "Poda de manutenção",
    pruning_protocol_title: "Preencher protocolo de poda",
    pruning_remedial: "Poda de reabilitação (poda de conservação / poda de correção)",
    pruning_safety: "Poda de segurança (poda de segurança rodoviária)",
    pruning_type: "Tipo de medida de poda",
    pruning_type_display: "Tipo:",
    pruning_type_required: "Tipo de medida de poda (obrigatório)",
    reason: "Motivo / Ocasião",
    reason_display: "Motivo:",
    reason_label: "Motivo / Ocasião:",
    reason_placeholder: "regular, seca, ...",
    recommendation: "Recomendação:",
    remark_display: "Observação:",
    remark_optional: "Observação (opcional)",
    remarks: "Observações",
    remarks_display: "Observações:",
    remarks_label: "Observações",
    remove: "Remover",
    reschedule: "Reagendar",
    reschedule_title: "Reagendar a data",
    responsible_person: "Pessoa responsável",
    responsible_person_display: "Pessoa responsável:",
    responsible_person_required: "Pessoa responsável (obrigatório)",
    road_safe: "Seguro para o trânsito",
    road_safe_display: "Seguro para o trânsito:",
    save: "Guardar",
    scope: "Âmbito:",
    select_placeholder: "Selecionar",
    sensor_install_task: "Montar sensor na árvore",
    sensor_maintenance_task: "Realizar manutenção do sensor na árvore",
    short_description_optional: "Breve descrição (opcional)",
    short_description_placeholder: "Breve descrição",
    show_less: "Mostrar menos",
    show_more: "Mostrar mais",
    soil_dry: "seco",
    soil_moisture: "Humidade do solo",
    soil_moisture_display: "Humidade do solo:",
    soil_slightly_moist: "ligeiramente húmido",
    soil_wet: "molhado",
    sort_by_date: "Ordenar por data",
    sort_by_priority: "Ordenar por prioridade",
    status_commissioned: "Encomendado",
    status_done: "Feito",
    status_in_progress: "Em trabalho",
    status_not_done: "Não conseguido",
    status_planned: "Planeado",
    time: "Hora",
    today: "Hoje",
    tomorrow: "Amanhã",
    tree_care_measures: "Medidas de cuidado de árvores",
    tree_care_measures_hint:
      "p. ex., remoção de madeira morta, poda do perfil de espaço livre, poda de segurança da copa",
    tree_condition: "Estado da árvore",
    tree_condition_damage: "danos",
    tree_condition_display: "Estado da árvore:",
    tree_condition_healthy: "saudável",
    tree_condition_other: "outros",
    tree_condition_placeholder: "p. ex, saudável, danos, infestação fúngica",
    tree_condition_required: "Estado da árvore (obrigatório)",
    tree_condition_tilt: "inclinação",
    tree_condition_wilted_leaves: "folhas murchas",
    upload_document: "Carregar documento",
    upload_document_hint: "Salve aqui um PDF, imagem ou documento, ou clique",
    water_amount_display: "Quantidade de água:",
    water_amount_liters: "Quantidade de água (litros)",
    water_amount_required: "Por favor, indique a quantidade de água.",
    weather_cloudy: "nublado",
    weather_conditions: "Condições meteorológicas",
    weather_display: "Condições meteorológicas:",
    weather_dry: "seco",
    weather_rain_after: "chuva depois",
    weather_rain_before: "chuva antes",
    weather_sunny: "ensolarado",
    weather_windy: "ventoso",
    weeks: "semanas",
    within: "dentro de",
    yes: "Sim",
  },
  challenges: "Problemas durante o projeto / Desafios futuros",
  challenges_placeholder: "Que problemas surgiram? O que é que o cliente precisava?",
  change: "Alterar",
  change_image: "Alterar imagem",
  change_language: "Alterar idioma",
  change_logo: "Alterar logótipo",
  change_position: "Alterar posição",
  characters: "Caracteres",
  childTree: "Árvore subordinada",
  child_trees: "Árvores representadas",
  choose_file: "Selecionar ficheiro",
  choose_location: "Selecionar localização",
  choose_project: "Selecionar um projeto",
  choose_qr_to_scan: "Selecionar QR para digitalizar",
  choose_the_file_to_be_imported: "Selecionar o ficheiro a importar",
  choose_tree: "Selecionar uma árvore",
  city: "Cidade",
  clear: "Repor",
  clear_filter: "Limpar filtro",
  clearance_profile_pruning: "Poda do perfil de espaço livre",
  click_on_marker_to_select_tree: "Clicar no marcador para selecionar a árvore",
  cloase_area_list: "Fechar lista de localizações",
  close: "Fechar",
  close_areas_list: "Fechar lista de localizações",
  close_overlays: "Fechar sobreposições",
  close_sidebar: "Fechar barra lateral",
  close_time_controls: "Fechar controlos de tempo",
  completed: "Concluído",
  condition_reports: "Relatórios de estado",
  confirm: "Confirmar",
  confirm_delete: "Confirmar eliminação",
  confirm_delete_image: "Tem a certeza de que deseja eliminar esta imagem?",
  confirm_delete_task_message: "Tem a certeza de que deseja eliminar esta tarefa?",
  continue: "Continuar",
  cookie_consent: {
    accept_all: "Aceitar todos",
    accept_essential: "Apenas necessários",
    analytics_cookies: "Cookies de análise",
    analytics_cookies_description:
      "Estes cookies permitem-nos contar visitas e fontes de tráfego para que possamos medir e melhorar o desempenho do nosso website. Ajudam-nos a compreender quais as páginas mais populares e como os visitantes se movem pelo website.",
    banner_description:
      "Utilizamos cookies para lhe proporcionar a melhor experiência possível no nosso website. Pode ajustar as suas preferências ou aceitar todos os cookies.",
    banner_title: "Definições de cookies",
    cookie_policy: "Política de cookies",
    customize: "Personalizar",
    essential_cookies: "Cookies necessários",
    essential_cookies_description:
      "Estes cookies são essenciais para o funcionamento do website e não podem ser desativados. Normalmente são definidos apenas em resposta a ações realizadas por si, como definir as suas preferências de privacidade, iniciar sessão ou preencher formulários.",
    last_updated: "Última atualização",
    marketing_cookies: "Cookies de marketing",
    marketing_cookies_description:
      "Estes cookies podem ser definidos pelos nossos parceiros publicitários através do nosso website. Podem ser utilizados para criar um perfil dos seus interesses e mostrar-lhe publicidade relevante noutros websites.",
    preferences_cookies: "Cookies de preferências",
    preferences_cookies_description:
      "Estes cookies permitem ao website lembrar-se das suas escolhas (como o seu nome de utilizador, idioma ou região em que se encontra) e fornecer funcionalidades avançadas e mais personalizadas.",
    preferences_error: "Erro ao guardar as definições.",
    preferences_saved: "As suas definições de cookies foram guardadas.",
    privacy_policy: "Declaração de privacidade",
    save_preferences: "Guardar definições",
    settings_description:
      "Gerir as suas preferências de cookies. As alterações entram em vigor imediatamente.",
    settings_title: "Definições de cookies",
  },
  cost_analysis: "Análise de custos",
  country: "País",
  create_account: "Criar conta",
  create_customer: "Criar cliente",
  create_new_tree: "Criar nova árvore",
  create_task: "Criar tarefa",
  creating: "A criar",
  critical: "Crítico",
  critical_sensors: "Número total de sensores críticos",
  crown: "Copa",
  crown_care: "Cuidado da copa",
  crown_defects: "Danos na copa",
  crown_diameter: "Diâmetro da copa",
  crown_vitality: "Vitalidade da copa",
  current_theme: "Tema atual",
  custom_maintenance_type: "Tipo de manutenção personalizado",
  custom_range: "Intervalo personalizado",
  custom_range_info: "Selecionar intervalo de data e hora personalizado",
  customer: "Cliente",
  customer_attributes: "Atributos do cliente",
  customer_creation_code: "Código de criação de cliente",
  customer_name: "Nome do cliente",
  customer_statistics_description: "Visualizar estatísticas de clientes e resumo de dados",
  customer_type: "Tipo de cliente",
  customer_type_agriculture: "Agricultura",
  customer_type_city: "Cidade",
  customer_type_forestry: "Silvicultura",
  customer_type_science: "Ciência",
  customers: "Clientes",
  daily_changes_email: "E-mail diário de alterações",
  damage_severity: {
    critical: "Crítico",
    light: "Ligeiro",
    moderate: "Moderado",
    none: "Nenhum",
    severe: "Grave",
  },
  damage_severity_label: "Grau de dano",
  dashboard: {
    all_locations: "Todas as localizações",
    avg_age: "Idade média da árvore",
    avg_crown_diameter: "Diâmetro médio da copa",
    avg_height: "Altura média da árvore",
    avg_trunk_diameter: "Diâmetro médio do tronco da árvore",
    data_status: "Estado dos dados",
    greeting: "Olá",
    group_biometrics: "Biometria de árvores",
    group_inventory: "Inventário de árvores",
    group_recommendations: "Recomendações",
    group_sensors: "Sensores e estado",
    health_last_30_days: "Saúde dos últimos 30 dias",
    health_overview: "Visão geral",
    kpi_avg_age: "Idade média",
    kpi_avg_crown_diameter: "Diâmetro médio da copa",
    kpi_avg_height: "Altura média",
    kpi_avg_trunk_circumference: "Perímetro médio do tronco",
    kpi_critical_sensors: "Bateria vazia",
    kpi_disconnected_sensors: "Sensores desligados (últimas 3 horas)",
    kpi_maintenance_sensors: "Sensor mede valores implausíveis",
    kpi_recommended_actions: "Árvores com recomendação de ação",
    kpi_sensor_types: "Tipos de sensores",
    kpi_total_sensors: "Número de sensores",
    kpi_total_species: "Número de espécies de árvores",
    kpi_total_trees: "Número de árvores",
    last_30_days: "Últimos 30 dias",
    last_3_hours: "últimas 3 h",
    no_data: "Sem dados disponíveis",
    no_health_data: "Sem dados de saúde disponíveis",
    sensor_types: "Tipos de sensores",
    tasks_by_due_period: "Tarefas por período",
    title: "Painel de controlo",
    top_species: "Top 5 espécies de árvores",
    top_species_info_body:
      "Mostra as espécies de árvores mais frequentes no filtro atual. Os valores baseiam-se no número de árvores por espécie.",
    top_species_info_title: "Top 5 espécies de árvores",
    tree_health: "Saúde das árvores",
    view_sensors: "Ver sensores",
    view_tasks: "Ir para tarefas",
    view_trees: "Ver árvores",
    years_short: "Anos",
  },
  data_analysis: "Análise de dados",
  data_graphs: "Séries de medições e gráficos",
  data_interval_description: "Defina como os pontos de dados devem ser agrupados no gráfico.",
  data_interval_settings: "Definições de intervalo de dados",
  data_science: "Análise de dados",
  data_status: "Estado dos dados",
  date: "Data",
  date_time: "Data/Hora",
  datetime_photo: "Data em que a foto foi tirada",
  day: {
    fri: "Sexta-feira",
    mon: "Segunda-feira",
    sat: "Sábado",
    sun: "Domingo",
    thu: "Quinta-feira",
    tue: "Terça-feira",
    wed: "Quarta-feira",
  },
  day_friday: "Sex",
  day_monday: "Seg",
  day_saturday: "Sáb",
  day_sunday: "Dom",
  day_thursday: "Qui",
  day_tuesday: "Ter",
  day_wednesday: "Qua",
  days: "Dias",
  days_left: "dias restantes",
  deadwood_removal: "Remoção de madeira morta",
  default: "Padrão",
  default_legacy: "Padrão, antigo",
  default_liters: "Litros padrão",
  defect: "Com defeito",
  defect_sensor: "Sensor defeituoso detetado",
  defect_sensors_excluded: "Sensores com defeito são excluídos do cálculo",
  defect_sensors_info:
    "Sensores com defeito ou não alcançáveis (exibidos a cinzento) não são considerados no cálculo de saúde. Apenas sensores funcionais são incluídos no estado.",
  defect_types: "Tipos de danos",
  delete: "Eliminar",
  delete_task: "Eliminar",
  demo_project_warning: {
    description:
      "Está atualmente a utilizar uma conta de demonstração e tem apenas permissões limitadas.\nSe já é cliente e deseja acesso à sua conta de cliente, por favor contacte o suporte: support@treesense.net.\nSe ainda não é cliente, pode encomendar sensores através da nossa loja em https://www.treesense.net",
    title: "Conta de demonstração",
  },
  dendrometer: "Dendrómetro",
  dendrometer_sensor: "Dendrómetro",
  depth: "Profundidade",
  description: "Descrição do projeto",
  description_placeholder: "Descreva resumidamente o projeto",
  deselect_all: "Anular seleção",
  dev_eui: "DevEUI",
  development_phase: "Fase de desenvolvimento",
  development_trends: "Tendências de desenvolvimento",
  diameter: "Diâmetro",
  diameter_minus_start: "Alteração de diâmetro desde o início",
  dieback: "Madeira morta",
  disconnected_sensors: "Sensores desligados",
  documents: "Documentos",
  dont_have_an_account: "Não tem uma conta?",
  download: "Descarregar",
  download_csv: "Descarregar CSV",
  download_excel: "Descarregar Excel",
  download_pdf: "Descarregar PDF",
  download_project_csv: "Descarregar dados do projeto (ficheiros tsv)",
  download_project_data: "Descarregar todos os dados de sensores do projeto",
  download_sensor_data: "Descarregar dados do sensor",
  download_successful: "Descarga bem-sucedida",
  download_tree_details: "Descarregar detalhes das árvores (.pdf)",
  download_tree_list: "Descarregar lista de árvores (.xlsx)",
  downloading: "A descarregar…",
  drag_the_below_variables_to_graph_area: "Arraste as seguintes variáveis para a área do gráfico",
  drop_left: "Soltar à esquerda",
  drop_right: "Soltar à direita",
  drop_the_variable_to_get_data: "Deixe a variável cair. Continue!",
  drought_days: "Dias de seca",
  ds_enter_fullscreen: "Modo de foco",
  ds_exit_fullscreen: "Sair do modo de foco",
  ds_fetch_error_hint:
    "Por favor, reduza o intervalo de datas, selecione menos sensores ou tente novamente.",
  ds_fetch_error_message:
    "Não foi possível carregar os dados de séries temporais selecionados. O período escolhido ou o número de sensores pode ser demasiado grande.",
  ds_no_data_hint:
    "Não foram encontrados valores para os filtros selecionados e o período escolhido.",
  ds_no_data_message: "Sem dados disponíveis",
  ds_pending_reload_hint: 'Clique em "Carregar dados" para atualizar o gráfico.',
  ds_pending_reload_message:
    "O gráfico está oculto porque a sua seleção foi alterada e os dados ainda não foram recarregados.",
  due_date: "Data de vencimento",
  edit: "Editar",
  edit_customer: "Editar cliente",
  edit_inspection: "Editar controlo",
  edit_safety_assessment: "Editar verificação de segurança",
  edit_sensor: "Editar sensor",
  edit_task: "Editar tarefa",
  edit_user: "Editar utilizador",
  edit_vta: "Editar VTA",
  efc_info: {
    bullets: {
      a: "nFK = FK − PWP",
      b: "Mostra a água disponível para as plantas",
      c: "Importante para o planeamento da rega",
    },
    formula_intro:
      "É calculada como a diferença entre capacidade de campo e ponto de murcha permanente:",
    heading: "Capacidade de campo útil (nFK)",
    intro: "A nFK é a quantidade de água que está efetivamente disponível para as plantas.",
    note: "Valores altos = solo pode armazenar mais água e fornecer às plantas por mais tempo",
  },
  effective_field_capacity: "Capacidade de campo útil",
  either_fill_all_address_or_make_all_empty:
    "Ou preencher todos os endereços ou deixar todos vazios",
  email: "E-mail",
  email_field_is_required: "O campo de e-mail é obrigatório",
  email_notification: "Notificações por e-mail",
  email_schedule: "Horário de e-mail",
  end: "Data de fim",
  enter_email_address: "Introduzir endereço de e-mail",
  enter_the_email_address_associated_with_your_account_and_we_will_send_you_a_link_to_reset_your_password:
    "Introduza o endereço de e-mail associado à sua conta e enviar-lhe-emos um link para repor a sua palavra-passe.",
  error: {
    a_valid_threshold_is_required: "É necessário um limite válido",
    choose_location: "Escolher localização",
    form: "A introdução dos valores estava incorreta. Por favor, corrija-os e tente novamente.",
    hardware_serial_no_is_required: "O número de série do hardware é obrigatório",
    loading_customers: "Erro ao carregar clientes",
    loading_trees: "Erro ao carregar árvores",
    loading_users: "Erro ao carregar utilizadores",
    name_field_is_required: "O campo de nome é obrigatório",
    please_choose_genus: "Por favor, selecione o género de árvore",
    please_choose_species: "Por favor, selecione a espécie de árvore",
    something_went_wrong: "Algo correu mal",
    this_field_is_required: "Este campo é obrigatório",
  },
  error_loading_customers: "Erro ao carregar clientes",
  error_loading_trees: "Erro ao carregar árvores",
  error_loading_users: "Erro ao carregar utilizadores",
  evaluation: "Avaliação",
  existing_area: "Localização existente",
  expiration_date: "Data de validade",
  explanation: "Explicação",
  export: "Exportar",
  export_data: "Exportar dados",
  no_data_to_export: "Sem dados para exportar",
  export_sensor_description:
    "Exporta os valores de medição do sensor disponíveis para o período escolhido.",
  favorites: "Favoritos",
  fc_info: {
    after_rain: "Após rega ou chuva:",
    bullets: {
      a: "O excesso de água infiltra-se",
      b: "O solo ajusta-se à capacidade de campo",
      c: "É ideal começar a rega antes de atingir o PWP",
    },
    heading: "Capacidade de campo (FK)",
    intro:
      "A capacidade de campo é a quantidade máxima de água que o solo pode reter contra a gravidade.",
    note: "Valores típicos: 35–50% (dependendo do tipo de solo)",
  },
  feedback: "Feedback",
  feedback_category: "Categoria",
  feedback_category_bug: "Relatório de erro",
  feedback_category_feature_request: "Pedido de funcionalidade",
  feedback_category_positive: "Feedback positivo",
  feedback_description: "Descrição",
  feedback_priority: "Urgência",
  feedback_priority_critical: "Crítica",
  feedback_priority_high: "Alta",
  feedback_priority_low: "Baixa",
  feedback_priority_medium: "Média",
  feedback_problem_url: "URL do problema",
  feedback_screenshot: "Captura de ecrã",
  feedback_submit_success: "Feedback guardado com sucesso.",
  field_capacity: "Capacidade de campo",
  file_download_success: "Ficheiro descarregado com sucesso.",
  export_failed: "A exportação falhou. Por favor, tente novamente.",
  file_upload_successfully: "Ficheiro carregado com sucesso",
  files_selected: "Ficheiros selecionados",
  filter: "Filtrar",
  filter_by_location: "Filtrar por localização",
  filter_by_project: "Filtrar por projeto",
  filter_tasks: "Filtro",
  filters: "Filtros",
  findings: "Conclusões",
  first_name: "Nome próprio",
  focus_search: "Focar pesquisa",
  foliage_density: {
    full: "Completo",
    moderate: "Moderado",
    sparse: "Leve",
    very_sparse: "Muito leve",
  },
  foliagedensity: "Densidade de folhagem",
  forgotpassword: "Esqueceu a palavra-passe? ",
  formula_type: "Fórmula",
  from: "De",
  fungal_infection: "Infestação fúngica",
  future_tasks: "Futuras",
  gallery: "Galeria",
  general: "Geral",
  genus: "Género",
  german_name: "nome pt.",
  go_to_customers: "Ir para clientes",
  go_to_users: "Ir para utilizadores",
  greeting: "Olá",
  group_biometrics: "Biometria arbórea",
  group_inventory: "Inventário de árvores",
  group_sensors: "Status do sensor",
  growth_rate: {
    normal: "Normal",
    slow: "Fraco",
    stagnant: "Estagnado",
    vigorous: "Forte",
  },
  growth_rate_label: "Desempenho de crescimento",
  hardware_serial: "DevEUI",
  hardware_serial_imei: "DevEUI/IMEI",
  hardware_serial_imei_description:
    "A identificação única do sensor. Encontra-se no autocolante no módulo de envio. Para sensores LoRaWAN trata-se do DevEUI e para sensores NB-IoT do IMEI.",
  hardware_serial_no: "DevEUI",
  head_purning: "Poda da copa",
  health_of_tree_is_drying_out: "A saúde da árvore está a deteriorar-se",
  health_of_tree_is_good: "O estado de saúde da árvore é bom",
  health_of_tree_is_poor: "A saúde da árvore é má",
  health_overview: "Visão geral de saúde",
  health_priority: "Prioridade",
  health_state: "Estado da árvore",
  health_state_info: {
    heading: "Sistema de semáforo: Compreender a necessidade de rega",
    intro: "O sistema de semáforo mostra de relance se uma árvore precisa de ser regada:",
    note: "Importante: O semáforo baseia-se em valores medidos e limites configurados para esta árvore, tipo de solo e localização.",
    states: {
      blue_help: "Rega excessiva; perigo de encharcamento.",
      blue_label: "🔵 Azul – Demasiado húmido:",
      gray_help: "Sensor não disponível ou sem dados.",
      gray_label: "⚪ Cinzento – Desconhecido:",
      green_help: "A árvore tem água suficiente.",
      green_label: "🟢 Verde – Sem necessidade de rega:",
      red_help: "Regar imediatamente!",
      red_label: "🔴 Vermelho – Rega urgentemente necessária:",
      yellow_help: "Se capacitativamente possível, regar agora.",
      yellow_label: "🟡 Amarelo – Rega recomendada:",
    },
  },
  health_states: {
    critical: "Crítico",
    critical_todo:
      "É muito provável que a árvore esteja a sofrer de stress hídrico. Regue-a o mais rápido possível.",
    determines_tree_status: "Este sensor determina o estado da árvore",
    disconnect: "Desligar",
    dry: "Seco",
    dry_todo: "A árvore deve ser regada ou verificada o mais rapidamente possível.",
    drying_out: "A secar",
    drying_out_todo: "A árvore deve ser regada.",
    frost: "Geada",
    frost_todo: "A árvore pode ter danos por geada.",
    healthy: "Sem stress de seca",
    healthy_todo: "Não precisa de fazer nada.",
    info_only: "Apenas para informação, não determina o estado da árvore",
    maintenance_needed: "Sensor mede valores implausíveis",
    maintenance_needed_todo:
      "Os valores do sensor parecem implausíveis. Verificar e fazer manutenção do sensor.",
    medium: "Médio",
    mixed_sensors: "Os sensores mostram estados diferentes",
    no_data: "Sem dados",
    no_data_todo: "Sensor está instalado mas não envia dados. Verificar ligação do sensor.",
    no_sensor: "Sem sensor",
    no_sensor_todo: "Sem sensor instalado. Instalar um sensor para monitorizar o stress de seca.",
    priority_1_crown: "Sensores da copa (se disponíveis, apenas estes)",
    priority_2_soil: "Sensores do solo (apenas se não houver sensores da copa)",
    priority_3_dendrometer: "Dendrómetro (apenas se não houver outros)",
    priority_explanation: "O estado de saúde baseia-se numa prioridade:",
    priority_note:
      "💡 Na vista detalhada, você pode ver todos os sensores. No entanto, o estado da árvore é determinado apenas pela prioridade mais elevada disponível.",
    priority_title: "Como é calculado o estado?",
    soil_needs_attention:
      "Os sensores do solo mostram valores críticos, embora a copa esteja saudável",
    status_from_crown:
      "Estado baseado no sensor da copa: {{crownStatus}}\n(Sensor do solo: {{soilStatus}} - apenas para informação)",
    status_from_soil: "Estado baseado no sensor do solo (sem sensores da copa disponíveis)",
    too_wet: "Demasiado húmido",
    too_wet_todo: "A árvore ou o solo parece estar demasiado húmido e não deve ser regada.",
    unknown: "Desconhecido",
    unknown_todo: "O sensor deve ser verificado.",
    wet: "Demasiado húmido",
    wet_todo: "A árvore ou o solo parece estar demasiado húmido e não deve ser regada.",
  },
  health_states_title: "Estados de saúde",
  healthy: "Saudável",
  heatmaps: "Mapas de calor",
  height: "Altura",
  help: "Ajuda",
  history: "Histórico",
  house_number: "Número",
  hypotheses: "Hipóteses a testar",
  hypotheses_placeholder: "Que hipóteses devem ser testadas?",
  image: "Imagem",
  imei: "IMEI",
  impact: "Impacto",
  import_export: "Importar/Exportar",
  import_trees: "Importar árvores",
  improvements: "Melhorias",
  inactive: "Inativo",
  include_advanced_calibration_values: "Incluir valores avançados de calibração/depuração",
  include_calculated_values: "Descarregar valores calculados",
  include_mean_values: "Incluir valores médios",
  include_mean_values_hint: "Adiciona valores médios para o período selecionado à exportação.",
  include_new_moisture_content_data: "Incluir novo índice de humidade (species mapping)",
  include_old_moisture_content_data: "Incluir antigo índice de humidade (choupo-negro)",
  include_species_mapping_data: "Incluir adicionalmente dados de calibração species-mapping",
  index: "Índice",
  info: "Informação",
  inspection_date: "Data de controlo",
  inspection_result: {
    failed: "Não aprovado",
    passed: "Aprovado",
    passed_with_notes: "Aprovado com observações",
  },
  inspection_result_label: "Resultado do controlo",
  inspection_type: {
    detailed: "Exame detalhado",
    emergency: "Controlo de emergência",
    post_storm: "Controlo de danos por tempestade",
    routine: "Controlo regular",
    safety: "Controlo de segurança",
  },
  inspection_type_label: "Tipo de controlo",
  inspections: "Controlos",
  inspector: "Inspetor de árvores",
  install: "Instalar",
  install_sensor: "Instalar sensor",
  installation: "Instalação",
  installation_save_failed: "Não foi possível guardar a instalação. Por favor, tente novamente.",
  installed_at: "Data de montagem",
  installed_sensors: "Sensores instalados",
  interactive_map: "Mapa interativo",
  interval_settings: "Intervalo",
  invalid_date: "Data inválida",
  invalid_date_range: "A data de início deve ser posterior à data de fim.",
  invalid_email_address: "Endereço de e-mail inválido",
  irrigation: "Rega",
  irrigationArea: "Localizações",
  irrigation_area_assignees_hint:
    "Defina por localização a quem serão atribuídas automaticamente as tarefas de rega criadas ou preparadas por padrão.",
  irrigation_area_assignees_title: "Responsáveis por localização",
  irrigation_auto_create_task: "Criar tarefa automaticamente (sem recomendação)",
  irrigation_cycle_count_label: "Número de ciclos de rega",
  irrigation_default_volumes: "Quantidades padrão de rega",
  irrigation_interval_biweekly: "De 2 em 2 semanas",
  irrigation_interval_custom: "Personalizado (X dias)",
  irrigation_interval_daily: "Diariamente",
  irrigation_interval_title: "Intervalo de rega",
  irrigation_interval_weekly: "Semanalmente",
  irrigation_no_areas: "Sem localizações disponíveis.",
  irrigation_phase_default: "Sem fase (padrão)",
  irrigation_repeat_every: "Repetir a cada",
  irrigation_settings: "Rega",
  irrigation_settings_saved: "Definições de rega guardadas.",
  irrigation_stop_condition_title: "Condição de paragem",
  irrigation_stop_fixed_cycles: "Número fixo de ciclos",
  irrigation_stop_until_green: "Continuar até o estado de saúde voltar a verde",
  irrigation_suggestion_assignment_mode_area_default: "Pessoa responsável padrão por localização",
  irrigation_suggestion_assignment_mode_hint:
    "Selecione se as sugestões de rega são assumidas com a pessoa padrão por localização ou se a pessoa responsável é selecionada manualmente em cada aceitação.",
  irrigation_suggestion_assignment_mode_manual:
    "Selecionar pessoa responsável manualmente em cada aceitação",
  irrigation_suggestion_assignment_mode_title: "Responsabilidade pelas sugestões",
  irrigation_trigger_after_days: "Acionar após X dias",
  irrigation_trigger_conditions: "Condições de acionamento",
  irrigation_trigger_red: "Ativar com estado de saúde vermelho",
  irrigation_trigger_yellow: "Ativar com estado de saúde amarelo",
  irrigation_validation_custom_days: "Por favor, introduza um intervalo válido em dias.",
  irrigation_validation_fixed_cycles: "Por favor, introduza um número válido de ciclos.",
  keyboard_shortcuts: "Atalhos de teclado",
  kpi_avg_age: "Idade média",
  kpi_avg_crown_diameter: "Diâmetro médio da coroa",
  kpi_avg_height: "Altura média",
  kpi_avg_trunk_diameter: "Diâmetro médio do tronco",
  kpi_critical_sensors: "Sensores críticos",
  kpi_disconnected_sensors: "Sensores desligados (nas últimas 3 horas)",
  kpi_sensor_types: "Tipos de sensores",
  kpi_total_sensors: "Número de sensores",
  kpi_total_species: "Número de espécies de árvores",
  kpi_total_trees: "Número de árvores",
  language: "Idioma",
  language_description: "Selecione o seu idioma preferido",
  last_10_measurements: "Últimas 10 medições",
  last_battery: "Último valor de bateria",
  last_date: "Última data",
  last_measurements: "Últimas medições",
  last_name: "Apelido",
  last_value: "Último valor medido",
  latin_name: "nome lat.",
  latitude: "Latitude",
  leaf_photos: "Fotos de folhas",
  leave_empty_to_keep_current: "Deixar vazio para manter a palavra-passe atual",
  less_than_60_of_the_battery_remaining: "Menos de 60% de bateria restante",
  ligature_control: "Controlo de ligadura",
  limitations: "Limitações dos resultados / Significado",
  limitations_placeholder: "Qual é a relevância dos resultados? Quais são as limitações?",
  limits_alerts: "Alarmes e limites",
  live_monitoring: "Monitorização em tempo real",
  load_data: "Carregar dados",
  loading: "A carregar ...",
  loading_data: "A carregar dados...",
  loading_trees: "A carregar árvores…",
  location: "Localização",
  login: "Iniciar sessão",
  login_credentials: "Credenciais de acesso",
  logout: "Terminar sessão",
  longitude: "Longitude",
  looks_like_you_dont_have_selected_area_please_select_the_area_to_get_data:
    "Parece que não tem nenhuma área selecionada. Por favor, selecione uma área para obter dados.",
  looks_like_you_dont_have_selected_sensor_please_select_a_sensor_to_get_data:
    "Parece que não tem nenhum sensor selecionado. Por favor, selecione um sensor para obter dados.",
  looks_like_you_dont_have_selected_tree_please_select_a_tree_to_get_data:
    "Parece que não tem nenhuma árvore selecionada. Por favor, selecione uma árvore para obter dados.",
  lora_wan: "LoRaWAN",
  maintainance: "Manutenção",
  maintenance: "Medidas de manutenção",
  maintenance_needed: "Sensor mede valores implausíveis",
  manage_customers_description: "Gerir informações e acesso de clientes",
  manage_parent_child_relationships: "Gerir relações pai-filho",
  manage_trees_without_sensors: "Gerir árvores sem sensores",
  manage_users_description: "Gerir contas de utilizador e permissões",
  map_add_tree_hint: "Mova o mapa para definir a posição da árvore.",
  map_add_tree_mode: "Modo de posicionamento ativo",
  map_sidebar_info: {
    description:
      "Esta barra lateral mostra todas as áreas de rega e suas árvores numa lista hierárquica.",
    features: {
      add_tree_help: "Utilizar o símbolo de mais para adicionar novas árvores a uma área.",
      add_tree_label: "Adicionar árvore:",
      expand_areas_help: "Clicar numa área para mostrar todas as árvores associadas.",
      expand_areas_label: "Expandir áreas:",
      parent_child_help:
        "Árvores com sensores podem funcionar como árvores-mãe e representar outras árvores.",
      parent_child_label: "Relações pai-filho:",
      select_tree_help: "Clicar numa árvore para exibi-la no mapa e abrir detalhes.",
      select_tree_label: "Selecionar árvore:",
    },
    features_heading: "Funcionalidades:",
    heading: "Navegação na vista de mapa",
    note: "A codificação de cores das árvores corresponde ao seu estado de saúde (verde = saudável, amarelo = a secar, vermelho = seco, cinzento = desconhecido).",
    title: "Vista de mapa – Áreas e árvores",
  },
  map_view: "Vista de mapa",
  mark_all_as_seen: "Marcar todas como lidas.",
  mark_as_Seen: "Marcar como visto",
  master_data: "Gestão de dados mestre",
  materials: "Ficheiros/Fotografias/Materiais do projeto",
  materials_placeholder: "Links para ficheiros, fotografias ou outros materiais",
  maximum_of: "Máximo",
  mean: "Valor médio",
  meaning_measurement: "Significado dos valores do sensor",
  measure_type_free_entry: "Registo livre",
  measure_type_inspection: "Controlo regular",
  measure_type_irrigation: "Rega",
  measure_type_pruning: "Medida de poda",
  measure_type_sensor_maintenance: "Manutenção de sensores",
  measure_type_soil_maintenance: "Manutenção do solo",
  menu: "Menu",
  methodology: "Como responder à pergunta? (Metodologia, seleção de árvores, instalação)",
  methodology_placeholder:
    "Descreva a metodologia, os locais, a seleção das árvores, a instalação dos sensores...",
  mobile_column: "Coluna",
  mobile_table_column_preferences: "Colunas móveis",
  mobile_table_column_preferences_hint:
    "Defina quais as 2 colunas que são exibidas em dispositivos móveis (telemóvel).",
  moisture_content: "Índice de humidade TreeSense",
  moisture_content_cap_description:
    "Limitar valores a 0-1 / 0-100%. Desativar para exibir valores brutos analíticos.",
  moisture_content_cap_setting: "Limitar valores de teor de humidade",
  moisture_content_display_description:
    "Selecione como o TreeSense apresenta os valores do teor de humidade.",
  moisture_content_display_fraction: "Fração (0-1)",
  moisture_content_display_fraction_description: "Exibe valores como 0,34.",
  moisture_content_display_percent: "Percentagem (0-100)",
  moisture_content_display_percent_description: "Exibe valores como 34%.",
  moisture_content_display_setting: "Exibição de teor de humidade",
  moisture_formula_hint:
    "A nova fórmula compensa melhor os efeitos de temperatura e fornece valores mais estáveis.",
  moisture_formula_improvements:
    "Melhorámos significativamente e automatizámos a configuração para calibração de temperatura. Anteriormente, apenas o choupo-negro era compensado. Agora tentamos compensar o maior número possível de espécies de árvores. Se isto não for possível, utilizamos a espécie de árvore filogeneticamente mais próxima.",
  moisture_formula_learn_more: "Saber mais",
  moisture_formula_new_description:
    "Em geral, é mais estável, uma vez que, normalmente, compensa melhor o efeito da temperatura. No entanto, isto pode fazer com que seja mais difícil detetar eventuais regas ou chuvas.",
  moisture_formula_note:
    "Nota: A escolha da fórmula influencia a exibição dos valores de humidade em todos os gráficos.",
  moisture_formula_old_description:
    "Está mais sujeito a oscilações de temperatura, mas permite indicar com maior precisão as regas e os episódios de chuva.",
  moisture_formula_setting: "Fórmula de teor de humidade",
  moisture_formula_threshold_warning:
    "Com a nova fórmula, os valores-limite também se alteram. Estes terão de ser verificados e ajustados após a transição, para que os avisos e as avaliações continuem a ser corretos.",
  moisture_formula_wiki_link:
    "https://www.treesense.net/wiki_post/treesense-pulse-was-ist-der-treesense-feuchtigkeitsindex/",
  month_april: "Abril",
  month_august: "Agosto",
  month_december: "Dezembro",
  month_february: "Fevereiro",
  month_january: "Janeiro",
  month_july: "Julho",
  month_june: "Junho",
  month_march: "Março",
  month_may: "Maio",
  month_november: "Novembro",
  month_october: "Outubro",
  month_september: "Setembro",
  more_actions: "Mais ações",
  more_information: "Mais informações",
  more_tasks: "mais",
  move_down: "Mover para baixo",
  move_up: "Mover para cima",
  name: "Nome",
  navigation: "Navegação",
  nb_iot: "NB-IoT",
  network_type: "Tipo de rede",
  new_area: "Nova localização",
  new_formula: "Nova fórmula",
  new_project: "Novo projeto",
  new_task: "Nova tarefa",
  newproject: "Novo projeto",
  next_inspection: "Próximo controlo",
  next_inspection_date: "Próxima data de controlo",
  next_irrigation: "Próxima rega",
  no_data: "Sem dados disponíveis",
  no_data_available_please_check_data_available_to_this_date:
    "Sem dados disponíveis, por favor verifique os dados disponíveis até esta data",
  no_data_for_selected_range:
    "Sem dados disponíveis para o período escolhido e os parâmetros selecionados.",
  no_data_found: "Sem dados encontrados",
  no_health_data: "Não existem dados de saúde disponíveis",
  no_inspections: "Não foram registados controlos",
  no_installation: "Sem instalação",
  no_photos: "Não foram carregadas fotos",
  no_project_selected: "Nenhum projeto selecionado",
  no_projects_available: "Não há projetos disponíveis",
  no_results: "Sem resultados",
  no_results_action: "Repor filtro",
  no_safety_assessments: "Não foram registadas verificações de segurança",
  no_sensor_is_selected: "Nenhum sensor selecionado",
  no_sensor_mode: "Modo sem sensores",
  no_sensors_found: "Nenhum sensor encontrado",
  no_tasks: "Não há tarefas existentes",
  no_tasks_subtitle: "Criar a sua primeira tarefa",
  no_tree_is_selected: "Nenhuma árvore selecionada",
  no_trees_available: "Não há árvores disponíveis",
  no_trees_found: "Nenhuma árvore encontrada",
  no_vta_assessments: "Sem exames VTA registados",
  not_found: "Não encontrado",
  not_provided: "Não registado",
  not_sending: "Não envia",
  note: "Nota",
  notes: "Notas",
  notifications: "Notificações",
  number_of_tree_based_on_health_status: "Número de árvores com base no estado de saúde",
  number_of_tree_on_respective_area: "Número de árvores na respetiva área",
  of: "de",
  okay: "Razoável",
  old_formula: "Fórmula antiga",
  one_day: "1 dia",
  one_day_info: "Mostrar dados das últimas 24 horas",
  one_week: "1 semana",
  one_week_info: "Mostrar dados dos últimos 7 dias",
  one_year: "1 ano",
  one_year_info: "Mostrar dados dos últimos 12 meses",
  open: "Abrir",
  open_questions: "Questões em aberto / Próximos passos",
  open_questions_placeholder: "Que questões continuam em aberto? Quais são os próximos passos?",
  open_sidebar: "Abrir barra lateral",
  open_time_controls: "Abrir o controlador de tempo",
  optional_soil_name: "Nome do solo opcional",
  other: "Outros",
  overall: "Geral",
  overdue: "Atrasado",
  overview: "Visão geral",
  pagination_out_of: "de",
  parentTree: "Árvore principal",
  parent_child_mode: "Modo pai-filho",
  password: "Palavra-passe",
  password_do_not_match: "A palavra-passe não coincide",
  password_field_is_required: "O campo de palavra-passe é obrigatório",
  password_reset_request_sent_generic:
    "Se existir uma conta para este endereço de e-mail, enviar-lhe-emos um link para repor a palavra-passe",
  past_tasks: "Anteriores",
  permanent_wilting_point: "Ponto de murcha permanente",
  persona: "Persona",
  persona_labels: {
    city_tree_manager: "Gestor/a de árvores municipal",
    irrigation_team: "Equipa de rega",
    research_partner: "Parceiro/a de investigação",
    tree_inspector: "Inspetor/a de árvores",
    treesense_support: "Suporte TreeSense",
  },
  personal_data: "Dados pessoais",
  pest_infestation: "Infestação de pragas",
  phase: "Fase",
  phone_number: "Número de telefone",
  photos: "Fotos",
  planting_time: "Tempo de plantação",
  planting_year: "Ano de plantação",
  please_drag_the_variable_to_display_data: "Por favor, arraste a variável para exibir dados.",
  please_select_project: "Por favor, selecione um projeto para visualizar dados",
  please_select_project_to_view_map: "Por favor, selecione um projeto para visualizar o mapa",
  please_select_sensor: "Por favor, selecione um sensor.",
  position: "Posição",
  position_confirmed: "Posição confirmada",
  print_tree_tag: "Imprimir etiqueta da árvore",
  priority: {
    high: "Alta",
    low: "Baixa",
    medium: "Média",
    urgent: "Urgente",
  },
  priority_high: "Alta",
  priority_low: "Baixa",
  priority_medium: "Média",
  problem_in_creating_customer: "Problema ao criar cliente",
  problem_in_creating_sensor: "Problema ao criar sensor",
  profile: "Perfil",
  proj: "Projeto",
  project: {
    aim: "Tipo de projeto",
    aim_general_drought_stress_monitoring: "Monitorização geral de stress por seca",
    aim_groundwater_lowering_monitoring: "Monitorização de rebaixamento do lençol freático",
    aim_irrigation_demand_determination: "Determinar necessidades de rega",
    aim_irrigation_optimization: "Otimização da rega",
    aim_irrigation_optimization_young_trees: "Otimização da rega: árvores jovens",
    aim_mistletoe_control: "Controlar infestação de visco",
    aim_old_tree_monitoring: "Monitorização de árvores antigas",
    aim_partnership_project: "Projeto de parceria",
    aim_smart_city: "Cidade inteligente",
    aim_technology_validation: "Validar tecnologia",
    challenges: "Problemas durante o projeto",
    challenges_placeholder: "Que problemas ocorreram? O que o cliente necessitou?",
    description: "Descrição do projeto",
    description_placeholder: "Descrever brevemente o projeto",
    hypotheses: "Hipóteses a testar",
    hypotheses_placeholder: "Que hipóteses devem ser testadas?",
    limitations: "Limitações para o resultado / significância",
    limitations_placeholder: "Qual é a significância dos resultados? Que limitações existem?",
    materials: "Ficheiros/Fotos/Material do projeto",
    materials_placeholder: "Links para ficheiros, fotos ou outro material",
    methodology: "Metodologia",
    methodology_placeholder:
      "Descrever a metodologia, localizações, seleção de árvores e montagem de sensores...",
    name: "Projeto",
    open_questions: "Questões em aberto / Próximos passos",
    open_questions_placeholder: "Que questões ainda estão em aberto? Quais são os próximos passos?",
    research_question: "Questão de investigação",
    research_question_placeholder: "Qual é a questão central de investigação?",
    results: "Resultados",
    results_placeholder: "Quais são os principais resultados do projeto?",
    select_aim: "Selecionar tipo de projeto",
  },
  project_details: {
    empty_project: "Projeto vazio, por favor comece por adicionar árvores.",
    empty_sensors: "Sem sensores criados, comece por adicionar sensores.",
    empty_trees: "Sem árvores criadas, por favor comece por adicionar árvores.",
    no_area_selected: "Por favor, selecione uma área para visualizar detalhes",
    no_sensor_selected: "Por favor, selecione um sensor para visualizar detalhes",
    no_tree_selected: "Por favor, selecione uma árvore para visualizar detalhes",
  },
  project_name: "Projeto",
  project_not_found: "Projeto não encontrado",
  projects: "Projetos",
  projects_views: "Projetos",
  pulse_resistance_in_kOhm: "Resistência de pulso em kOhm",
  pulse_sensor: "Sensor da copa",
  push_message_notification: "Notificações push",
  pwp_info: {
    bullets: {
      a: "A planta já não consegue absorver água suficiente",
      b: "Podem ocorrer danos irreversíveis",
      c: "A rega imediata é crítica",
    },
    heading: "Ponto de murcha permanente (PWP)",
    intro:
      "O ponto de murcha permanente é o teor de água do solo em que as plantas já não conseguem absorver água.",
    note: "Valores típicos: 10–15% (dependendo do tipo de solo)",
    when_reached: "Quando a humidade do solo atinge ou fica abaixo deste valor:",
  },
  qr_scanner: "Scanner QR",
  rain: "Chuva",
  rainfall: "Precipitação",
  rainfall_mm: "Precipitação (mm)",
  reason: "Motivo",
  recommendations: "Recomendações",
  records: "Registos",
  reference: "Referência",
  refresh_health: "Atualizar dados de saúde",
  refresh_health_error: "Falha na atualização dos dados de saúde",
  remove: "Remover",
  remove_3d_model: "Remover modelo 3D",
  removed_at: "Data de desmontagem",
  replace_3d_model: "Substituir modelo 3D",
  report_after: "Depois",
  report_avg_control_interval: "Intervalo médio de controlo",
  report_avg_moisture_index: "Índice médio de humidade",
  report_avg_moisture_over_time: "Índice de humidade ao longo do tempo",
  report_avg_violation_to_completion: "Tempo médio de violação até conclusão",
  report_batteries_low: "Baterias < 20%",
  report_before: "Antes",
  report_before_after_analysis: "Análise antes/depois",
  report_completed_tasks: "Tarefas concluídas",
  report_controls_per_month: "Controlos por mês",
  report_controls_performed: "Controlos realizados",
  report_critical_trees: "Árvores críticas",
  report_critical_vs_completed: "Árvores críticas vs. medidas concluídas",
  report_critical_with_open_task: "Árvores críticas com tarefa aberta",
  report_date: "Data",
  report_documented_maintenance: "Medidas documentadas",
  report_effect_tab: "Relatório de impacto",
  report_health_distribution: "Distribuição do estado de saúde",
  report_index_change_after_irrigation: "Alteração do índice após rega",
  report_index_change_after_pruning: "Alteração do índice após poda",
  report_irrigation_vs_index: "Regas vs. índice de humidade",
  report_kataster_tab: "Relatório de cadastro",
  report_maintenance_type_distribution: "Distribuição de tipos de medidas",
  report_offline_sensors: "Sensores offline",
  report_overdue_tasks: "Tarefas atrasadas",
  report_rain_vs_index: "Chuva vs. índice de humidade",
  report_range_1m: "1 mês",
  report_range_1w: "1 semana",
  report_range_1y: "1 ano",
  report_range_3m: "3 meses",
  report_sensor_tab: "Relatório de sensores",
  report_task_status_distribution: "Distribuição do estado das tarefas",
  report_threshold_violations: "Violações de limites",
  report_total_active_sensors: "Sensores ativos",
  report_total_trees: "Número de árvores",
  report_violations: "Violações",
  reporting: "Relatórios",
  reports_analysis: "Análises e relatórios",
  represent_tree: "Exibir árvore",
  represented_tree: "Árvore exibida",
  required: "Necessário",
  required_information: "* Informações necessárias",
  research_question: "Questão de investigação/Objetivos do projeto",
  research_question_placeholder: "Qual é a questão principal ou o objetivo deste projeto?",
  reset: "Repor",
  reset_chart: "Repor gráfico",
  reset_filters: "Repor todos",
  reset_info: "Repor todas as definições do gráfico para padrão",
  reset_password: "Repor palavra-passe",
  reset_table_column_preferences: "Restaurar padrão",
  reset_zoom: "Repor ampliação",
  resis_temp_comp: "ResisTempComp",
  resistance: "Resistência",
  resource_planning: "Planeamento de recursos",
  restore_view: "Restaurar visualização",
  results: "Resultados",
  results_placeholder: "Quais são os principais resultados do projeto?",
  risk_assessment: "Avaliação de risco",
  risk_level: {
    critical: "Risco crítico",
    high: "Risco alto",
    low: "Risco baixo",
    medium: "Risco médio",
  },
  risklevel: "Nível de risco",
  role: "Função",
  root_ball: "Torrão",
  root_defects: "Danos nas raízes",
  root_system: {
    DE: "Raíz profunda",
    HE: "Raíz coração",
    SH: "Raíz superficial",
    UN: "Desconhecido",
  },
  safety_status: {
    action_required: "Medidas necessárias",
    monitoring_required: "Observação necessária",
    safe: "Seguro",
    unsafe: "Inseguro",
  },
  save: "Guardar",
  save_changes: "Guardar alterações",
  save_settings: "Guardar definições",
  saved: "Guardado",
  saving: "A guardar ...",
  scan_to_add_sensor: "Digitalizar para adicionar sensor",
  search: "Pesquisar",
  search_address: "Pesquisar endereço",
  search_area: "Pesquisar localização",
  search_sensor: "Pesquisar sensor",
  search_sensors: "Pesquisar sensores...",
  search_tasks: "Pesquisar tarefas...",
  search_tree: "Pesquisar árvore",
  search_trees: "Pesquisar árvores...",
  select_all: "Selecionar tudo",
  select_camera: "Selecionar câmara",
  select_child_trees: "Selecionar árvores-filhas",
  select_customer_type: "Selecionar tipo de cliente",
  select_depth: "Selecionar profundidade",
  select_language: "Selecionar idioma",
  select_phase: "Selecionar fase",
  select_project: "Selecionar projeto",
  select_sensor: "Selecionar sensor",
  select_sensor_search: "Pesquisar sensor...",
  select_task_types: "Selecionar tipos de tarefa",
  select_year: "Selecionar ano",
  send_feedback: "Enviar feedback",
  sending: "A enviar...",
  sensor: "Sensor",
  sensor_already_installed: "Este sensor já está instalado e ativo",
  sensor_configuration: "Configuração de sensores",
  sensor_data: "Dados do sensor",
  sensor_details: {
    empty_sensors: "Sem sensor, por favor comece por adicionar sensores.",
    no_data_found: "Sem dados de sensor encontrados",
    no_recent_measurements: "Sem valores de medição nos últimos 3 meses.",
    no_recent_measurements_hint:
      "Para verificar dados mais antigos, utilize a análise de dados e ajuste o período.",
    no_sensor_selected: "Por favor, selecione um sensor para visualizar detalhes",
  },
  sensor_disconnect: "Sensor desligado",
  sensor_form: {
    hardware_serial: "DevEUI/IMEI",
    name: "Nome",
    network_type: "Tipo de rede",
    sensor_type: "Tipo de sensor",
    threshold: "Limite",
  },
  sensor_name: "Nome do sensor",
  sensor_state: "Estado do sensor",
  sensor_status: "Estado do sensor",
  sensor_status_change_to_dry: "Alteração do estado do sensor: Vermelho/stress de seca",
  sensor_status_change_to_drying_out:
    "Alteração do estado do sensor: Amarelo/stress ligeiro de seca",
  sensor_status_change_to_no_connection:
    "Alteração do estado do sensor: Cinzento/sem receção de dados",
  sensor_status_description:
    "O estado do sensor indica se o sensor está a funcionar ou se necessita de manutenção, por exemplo.",
  sensor_type: "Tipo de sensor",
  sensor_types: "Tipos de sensores",
  sensors: "Sensores",
  sensors_monitoring: "Sensores e monitorização",
  sensors_views: "Sensores",
  sesnor_height_hint:
    "Arrastar ícone do sensor ou introduzir a altura. Os valores são arredondados.",
  set_default: "Repor valores",
  settings: "Definições",
  settings_saved_successfully: "Definições guardadas com sucesso",
  settings_user_info: {
    persona: {
      city_tree_manager: {
        changes:
          "['Página padrão: Painel de controlo', 'Foco: Visão geral, cadastro e trabalho próximo de relatórios']",
        description:
          "Perfil UX para utilizadores que necessitam de uma visão geral de gestão sobre painel de controlo, cadastro e análises.",
      },
      irrigation_team: {
        changes: "['Página padrão: Tarefas', 'Foco: Processos de rega e execução operacional']",
        description:
          "Perfil UX para utilizadores que trabalham principalmente em processos de rega e execução orientados por tarefas.",
      },
      research_partner: {
        changes:
          "['Página padrão: Data Science', 'Foco: Exploração, dados de sensores e análises']",
        description:
          "Perfil UX para utilizadores que trabalham principalmente em Data Science e análise baseada em sensores.",
      },
      tree_inspector: {
        changes:
          "['Página padrão: Cadastro de árvores', 'Foco: Inspeções, dados de árvores e trabalho de campo']",
        description:
          "Perfil UX para utilizadores que trabalham principalmente no cadastro de árvores e realizam inspeções no terreno.",
      },
      treesense_support: {
        changes:
          "['Página padrão: Sensores', 'Foco: Estado dos sensores e fluxos de trabalho de suporte técnico']",
        description:
          "Perfil UX para utilizadores que monitorizam sensores e processam processos de suporte técnico.",
      },
    },
    persona_footer:
      "As personas controlam o ponto de entrada padrão e o foco UX. As permissões efetivas continuam a vir das permissões das funções de backend.",
    persona_section_title: "O que muda na interface do utilizador",
    role: {
      admin: {
        changes:
          "['Pode gerir processos organizacionais sem ter responsabilidade completa pela plataforma', 'Normalmente tem amplo acesso ao nível do cliente, dependendo das permissões de backend']",
        description:
          "Função administrativa para gestão relacionada com clientes e processos organizacionais.",
      },
      basic: {
        changes:
          "['Trabalha dentro de projetos e áreas atribuídos', 'As atribuições de áreas são particularmente relevantes para o acesso operacional']",
        description:
          "Função de utilizador final operacional para trabalho diário em projetos e áreas atribuídos.",
      },
      superuser: {
        changes:
          "['Pode gerir utilizadores, definições e administração relacionada com clientes', 'Normalmente tem o acesso mais amplo através dos módulos']",
        description:
          "Função administrativa completa com acesso irrestrito a áreas de configuração e gestão.",
      },
    },
    role_footer:
      "As funções determinam as permissões efetivas. As personas influenciam apenas a navegação padrão e o foco UX.",
    role_section_title: "O que muda no acesso",
  },
  show_all_trees: "Mostrar todas as árvores",
  show_shortcuts: "Mostrar atalhos de teclado",
  show_tree_list: "Mostrar lista de árvores",
  showing: "A mostrar",
  showing_results: "A mostrar {{count}} resultados",
  signup: "Registo",
  single_tree_view: "Vista de árvore individual",
  six_months: "6 meses",
  six_months_info: "Mostrar dados dos últimos 6 meses",
  size: "Tamanho",
  skip: "Saltar",
  soil: "Solo",
  soil_info: {
    heading: "Compreender parâmetros do solo",
    intro:
      "Estes valores descrevem a capacidade de armazenamento de água do solo nesta localização:",
    items: {
      efc_help:
        "Quantidade de água que as plantas podem efetivamente absorver (entre PWP e capacidade de campo).",
      efc_label: "Capacidade de campo útil (nFK):",
      fc_help: "Quantidade máxima de água que o solo pode reter contra a gravidade.",
      fc_label: "Capacidade de campo (FK):",
      pwp_help:
        "Teor de água abaixo do qual as plantas não conseguem absorver água suficiente e murcham.",
      pwp_label: "Ponto de murcha permanente (PWP):",
    },
    note: "Estes parâmetros são configurados especificamente para a localização e influenciam as recomendações de rega.",
  },
  soil_moisture: "Humidade do solo",
  soil_moisture_edit: "Limites de humidade do solo vol.",
  soil_moisture_sensor: "Sensor de humidade do solo",
  soil_moisture_vg: "Humidade do solo (van Genuchten)",
  soil_name: "Nome do solo",
  soil_water_tension: "Tensão de água no solo",
  soil_water_tension_edit: "Limites de tensão de água no solo",
  soil_water_tension_sensor: "Sensor de tensão de água no solo",
  soil_water_tension_vg: "Tensão de água no solo (van Genuchten)",
  something_wrong: "Algo correu mal",
  species: "Espécie",
  start_scanning: "Iniciar digitalização",
  start_typing_to_search: "Começar a escrever para pesquisar...",
  start_with_adding_new_project: "Começar por adicionar um novo projeto",
  state: "Estado",
  statistics: "Estatísticas",
  stats_completed: "Concluídas",
  stats_in_progress: "Em progresso",
  stats_overdue: "Atrasadas",
  stats_total: "Total de tarefas",
  status: "Estado",
  status_BEAUFTRAGT: "Encomendado",
  status_ERLEDIGT: "Feito",
  status_GEPLANT: "Planeado",
  status_IN_ARBEIT: "Em trabalho",
  status_NICHT_GESCHAFFT: "Não conseguido",
  status_completed: "Concluído",
  status_in_progress: "Em progresso",
  status_planned: "Planeado",
  status_review: "Em revisão",
  stem_cane_removal: "Remoção do tronco principal",
  stop_scanning: "Parar digitalização",
  street_name: "Rua",
  structural_defects: "Defeitos estruturais",
  superuser: "Super Utilizador",
  table_column_preferences: "Colunas visíveis",
  table_column_preferences_hint:
    "Defina quais as colunas que são exibidas nas tabelas de árvores, sensores e tarefas.",
  table_columns_sensors: "Sensores",
  table_columns_trees: "Árvores",
  table_columns_tasks: "Tarefas",
  task: "Tarefa",
  task_assignee: "Atribuído a",
  task_assignee_select_placeholder: "Selecionar pessoa",
  task_attachments: "Anexos",
  task_comments: "Comentários",
  task_description: "Descrição",
  task_description_placeholder: "Introduzir descrição",
  task_details: "Detalhes da tarefa",
  task_due_date: "Data de vencimento",
  task_filter_due_period: "Período",
  task_filter_measure_type: "Tipo de tarefa",
  task_filter_overdue: "Em atraso",
  task_filter_pruning_type: "Tipo de poda",
  task_filter_this_month: "Este mês",
  task_filter_this_week: "Esta semana",
  task_filter_today: "Hoje",
  task_form: {
    assigned_to: "Atribuído a",
    assignment: "Atribuição",
    basic_info: "Informações básicas",
    created_at: "Criado em",
    created_by: "Criado por",
    description: "Descrição",
    description_placeholder: "Introduzir descrição da tarefa",
    due_date: "Data de vencimento",
    priority: "Prioridade",
    priority_high: "Alta",
    priority_low: "Baixa",
    priority_medium: "Média",
    select_task_to_view: "Selecione uma tarefa para visualizar detalhes",
    select_user: "Selecionar utilizador",
    status: "Estado",
    status_completed: "Concluído",
    status_in_progress: "Em progresso",
    status_pending: "Pendente",
    title: "Título",
    title_placeholder: "Introduzir título da tarefa",
    tree: "Árvore",
  },
  task_location: "Localização",
  task_location_placeholder: "Introduzir localização",
  task_priority: "Prioridade",
  task_status: "Estado",
  task_suggestion_bulk_create: "Criar seleção",
  task_suggestion_bulk_created_success: "Criação de recomendações selecionadas.",
  task_suggestion_bulk_dismiss: "Rejeitar seleção",
  task_suggestion_bulk_dismissed_success: "Recomendações selecionadas rejeitadas.",
  task_suggestion_bulk_manual_only:
    "No modo manual, as sugestões de rega só podem ser aceites individualmente.",
  task_suggestion_choose_assignee_body:
    "Selecione a quem será atribuída a tarefa de rega ao aceitar esta sugestão.",
  task_suggestion_choose_assignee_title: "Selecionar pessoa responsável",
  task_suggestion_choose_assignee_validation: "Por favor, selecione uma pessoa.",
  task_suggestion_create_task: "Criar tarefa",
  task_suggestion_created: "Criado",
  task_suggestion_created_success: "Tarefa criada a partir da recomendação.",
  task_suggestion_dismiss: "Rejeitar",
  task_suggestion_dismissed_success: "Recomendação rejeitada.",
  task_suggestion_health_red: "Vermelho",
  task_suggestion_health_yellow: "Amarelo",
  task_suggestion_reason_fallback: "Estado de saúde anómalo.",
  task_suggestions_empty: "Sem recomendações abertas.",
  task_suggestions_open_page: "Abrir recomendações",
  task_suggestions_pending_count: "recomendações abertas",
  task_suggestions_title: "Tarefas recomendadas",
  task_title: "Título",
  task_title_placeholder: "Introduzir título",
  task_tree_info: "Informações da árvore",
  task_tree_location: "Árvore e localização",
  task_tree_select: "Árvore",
  task_tree_select_placeholder: "Selecionar árvore",
  task_tree_species: "Espécie de árvore",
  task_tree_species_placeholder: "Introduzir espécie de árvore",
  tasks: "Tarefas",
  tasks_completed_short: "concluídas",
  tasks_workflows: "Tarefas",
  temperature: "Temperatura",
  the: "o/a",
  theme: "Design",
  theme_dark: "Escuro",
  theme_dark_desc: "Agradável para os olhos",
  theme_description: "Escolha como pretende que o TreeSense apareça",
  theme_light: "Claro",
  theme_light_desc: "Claro e nítido",
  theme_system: "Sistema",
  theme_system_desc: "Segue o seu dispositivo",
  three_weeks: "3 semanas",
  three_weeks_info: "Mostrar dados das últimas 3 semanas",
  threshold: "Limite",
  thresholds: "Limites",
  tick_the_checkbox_to_download_data: "Marcar a caixa para descarregar dados",
  ticket_system: "Sistema de tickets",
  time: "Tempo",
  time_range_info:
    "Selecione um período para visualizar dados históricos. Escolha entre intervalos predefinidos ou defina um período personalizado.",
  time_range_selection: "Seleção de período",
  timeframe: "Período",
  timeframe_hint:
    "Deixar inalterado para descarregar os últimos 30 dias. Ajustar o período para restringir a exportação.",
  to: "Até",
  today: "Hoje",
  toggle_mobile_menu: "Alternar menu móvel",
  toggle_project_sidebar: "Alternar barra lateral do projeto",
  tomorrow: "Amanhã",
  top_species: "As 5 principais espécies de árvores",
  top_species_info_body:
    "Mostre as cinco espécies de árvores mais frequentes na sua atual seleção.",
  top_species_info_title: "Espécies de árvores mais comuns",
  topiary: "Topiária",
  total_sensors: "Número total de sensores",
  total_trees: "Número total de árvores",
  total_trees_species: "Número total de espécies de árvores",
  tour_start: "Iniciar visita",
  traffic_safety_assessments: "Verificações de segurança rodoviária",
  traffic_safety_status: "Estado de segurança rodoviária",
  tree: "Árvore",
  treeNoSensor: "Árvore sem sensor",
  tree_added_successfully: "Árvore adicionada com sucesso",
  tree_and_sensor: "Árvore e sensor",
  tree_cadastre: "Cadastro de árvores",
  tree_cadastre_no: "N.º de cadastro da árvore",
  tree_control: "Controlo da árvore",
  tree_count: "Número de árvores",
  tree_form: {
    info: {
      represent: {
        heading: "Árvore de referência",
        help: "Selecione a árvore que representa esta localização para avaliações e relatórios.",
        note: "Para analisar os dados da melhor forma possível, recomendamos o carregamento de uma imagem da árvore e de uma folha significativa ao mesmo tempo.",
      },
      sensors: {
        heading: "Sensores",
        help: "Ordene os sensores que pertencem a esta árvore.",
        note: "Os sensores selecionados serão utilizados para exibir dados em tempo real e calcular recomendações de rega.",
      },
      soil: {
        heading: "Parâmetros do solo",
        max_f_help: "Valor máximo do sensor para árvores bem regadas (F = regadas).",
        max_f_label: "Valor máximo (árvores regadas)",
        max_nf_help: "Valor máximo do sensor para árvores não regadas (NF = não regadas).",
        max_nf_label: "Valor máximo (árvores não regadas)",
        note: "Estes valores limite são utilizados para determinar recomendações de rega e as cores do sistema de semáforos.",
        pwp_help: "Valor do sensor em que a árvore atinge o ponto de murcha permanente (PWP).",
        pwp_label: "Ponto de murcha permanente (PWP)",
      },
    },
    more_info: "Mais informações",
    position: "Posição",
    representTree: "Árvores subordinadas",
    sensors: "Sensores",
    soil: "Solo",
    tree_profile: "Perfil da árvore",
  },
  tree_form_info: {
    add_title: "Adicionar árvore",
    edit_title: "Editar árvore",
    more: {
      heading: "Mais informações",
      metrics_help: "Perímetro do tronco (cm), altura (m), diâmetro da copa (m) — opcional.",
      metrics_label: "Medidas:",
      note: "Útil para relatórios e recomendações; pode ser complementado posteriormente.",
      phase_help: "Selecionar conclusão, desenvolvimento ou manutenção.",
      phase_label: "Fase de cuidado:",
      species_help: 'Pesquisar no formato "nome lat. | nome pt.".',
      species_label: "Espécie de árvore:",
      year_help: "Selecionar ano de plantação.",
      year_label: "Ano de plantação:",
    },
    position: {
      altitude_help: "Opcional. Deixar vazio se desconhecido.",
      altitude_label: "Altitude:",
      heading: "Posição",
      latlng_help: "Campos obrigatórios. Introduzir coordenadas ou definir marcador no mapa.",
      latlng_label: "Latitude / Longitude*: ",
      map_help: "Utilizar ferramentas de mapa para ampliar/mover e definir a posição exata.",
      map_label: "Mapa:",
      note: "Coordenadas exatas melhoram análises e vistas de mapa.",
    },
    profile: {
      cadastre_help: "Identificação opcional do cadastro (máx. 24 caracteres).",
      cadastre_label: "N.º de cadastro da árvore:",
      heading: "Perfil da árvore",
      name_help: "Nome descritivo (máx. 40 caracteres).",
      name_label: "Nome:",
      note: "Estas informações podem ser editadas posteriormente nos detalhes da árvore.",
    },
    represent: {
      heading: "Árvore de representação",
      help: "Opcional definir, que esta árvore representa outras árvores (agrupamento).",
    },
    sensors: {
      heading: "Sensores",
      help: "Atribuir sensores TreeSense existentes a esta árvore ou desassociar.",
      note: "As atribuições podem ser alteradas posteriormente nos detalhes da árvore.",
    },
    soil: {
      heading: "Solo",
      max_f_help: "Valor típico, p. ex, 45.",
      max_f_label: "Capacidade de campo (max_f):",
      max_nf_help: "Valor típico, p. ex, 25.",
      max_nf_label: "Máx. água de campo utilizável (max_nf):",
      note: "Apenas necessário se trabalhar com estimativas de água do solo.",
      pwp_help: "Ponto de murcha permanente (por exemplo, 10).",
      pwp_label: "PWP:",
    },
  },
  tree_health: "Saúde das árvores",
  tree_info: "Informações da árvore",
  tree_info_help: {
    description:
      "Este separador mostra os dados mestre da árvore selecionada (espécie, medidas, localização e estado). Fornece contexto para valores de sensores e histórico de cuidados.",
    fields: {
      dimensions_help:
        "Altura, diâmetro da copa e perímetro do tronco com base nos últimos valores de inventário registados.",
      dimensions_label: "Dimensões:",
      location_help: "Coordenadas (WGS84 latitude/longitude) para localizar a árvore no mapa.",
      location_label: "Localização",
      species_help: "Nome científico (e nome português, se disponível).",
      species_label: "Espécie de árvore",
      status_help:
        "Estado atual (p. ex, sem stress de seca / stress de seca) – dependendo das regras do projeto e sensores disponíveis.",
      status_label: "Estado da árvore",
      year_phase_help:
        "Ano de plantação (evtl. estimado) e classificação numa fase de desenvolvimento/vida (p. ex, conclusão, desenvolvimento, envelhecimento).",
      year_phase_label: "Ano de plantação e fase",
    },
    fields_heading: "Descrição dos campos",
    heading: "O que se vê aqui",
    note: "Dica: Se estiver autorizado, pode editar dados mestre através do símbolo de lápis.",
  },
  tree_inventory: "Inventário de árvores",
  tree_management_mode: "Modo de gestão de árvores",
  tree_name: "Árvore",
  tree_phases: "Fases da árvore",
  tree_photos: "Fotos da árvore",
  tree_profile: {
    learn_more: "Clique aqui para saber mais",
    tree_info: "Informações da árvore",
    tree_species: "Informação interessante",
    tree_species_knowledge: "Factos",
  },
  tree_species: "Espécie de árvore",
  tree_stakes_control: "Controlo de estacas da árvore",
  tree_status: "Estado da árvore",
  tree_water_deficit: "Défice de água da árvore",
  tree_water_stress: "Stress de seca",
  tree_wiki: "Wiki da árvore",
  tree_with_sensor: "Árvore com sensor",
  tree_without_sensor: "Árvore sem sensor",
  treegenus: "Género de árvore",
  trees: "Árvores",
  trees_short: "Árvores",
  trees_views: "Árvores",
  treespecies: "Espécie de árvore",
  trunk_circumference: "Perímetro do tronco",
  trunk_defects: "Danos no tronco",
  trunk_protection: "Proteção do tronco",
  type: "Tipo",
  type_an_adress: "Introduzir endereço",
  type_of_maintenance: "Tipo de manutenção",
  unable_to_upload_file: "Não é possível carregar o ficheiro",
  unknown: "Desconhecido",
  update: "Atualizar",
  update_customer_logo_description: "Carregar e atualizar o logótipo da sua empresa",
  update_image: "Atualizar imagem",
  upload: "Carregar",
  upload_3d_model: "Carregar modelo 3D",
  upload_file: "Carregar ficheiro",
  upload_leaf_img: "Carregar imagem de folha",
  upload_tree: "Carregar árvore",
  upload_tree_img: "Carregar imagem da árvore",
  usable: "utilizável",
  use_my_location: "Utilizar a minha localização",
  use_new_moisture_formula: "Utilizar nova fórmula",
  user: "Utilizador/a",
  user_details: {
    empty_project: "Sem utilizador, por favor comece por adicionar árvores.",
    no_user_selected: "Por favor, selecione um utilizador para visualizar detalhes",
  },
  user_form: {
    address: "Endereço",
    areas: "Áreas de rega",
    basic_info: "Informações básicas",
    login_credentials: "Credenciais de acesso",
    profile: "Perfil",
  },
  user_invitation_email_hint:
    "Após guardar, o utilizador receberá um e-mail para definir a sua palavra-passe.",
  username: "Nome de utilizador",
  users: "Utilizadores/as",
  validation: {
    all_address_field_are_required: "Todos os campos de endereço são necessários",
    cadastre_or_name_required: "Deve ser indicado o n.º de cadastro da árvore ou o nome da árvore.",
    either_field_required: "* Pelo menos um destes campos é necessário.",
    email_is_required: "O e-mail é necessário",
    hardware_serial_is_required: "O número de série do hardware é necessário",
    hardware_serial_must_be_16_characters:
      "O número de série do hardware deve ter exatamente 16 caracteres.",
    imei_must_be_15_digits: "O IMEI deve conter exatamente 15 dígitos.",
    invalid_email_address: "Endereço de e-mail inválido",
    invalid_hex_identifier:
      "O identificador deve ser um valor hexadecimal válido em maiúsculas. Por favor, utilize apenas dígitos 0-9 e letras maiúsculas A-F.",
    invalid_house_number: "Número de porta inválido",
    must_be_a_number: "O valor deve ser um número",
    name_is_required: "O nome é necessário",
    out_of_range: "O valor deve estar entre {{min}} e {{max}}",
    password_is_required: "A palavra-passe é necessária",
    position_is_required: "A posição é necessária",
    required_fields: "* Campos necessários",
    sensor_limit_exceeded_for_your_package: "Limite de sensores excedido para o seu pacote",
    task_error: "A tarefa é necessária.",
    tree_limit_exceeded_for_your_package: "Limite de árvores excedido para o seu pacote",
    user_limit_exceeded_for_your_package: "Limite de utilizadores excedido para o seu pacote",
    user_with_this_email_already_exist: "Já existe um utilizador com este endereço de e-mail",
  },
  value: "Valor",
  variables: "Variáveis/Valores",
  view_calendar: "Calendário",
  view_kanban: "Kanban",
  view_list: "Lista",
  view_on_chart: "Ver em Data Science",
  view_on_list: "Ver em lista",
  view_on_map: "Ver no mapa",
  viewproject: "Ver projeto",
  views_per_page: "Visitas por página",
  vitality_stage: "Nível de vitalidade",
  vitality_stage_help:
    "0 = Vital, 1 = Ligeiramente enfraquecido, 2 = Enfraquecido, 3 = Fortemente enfraquecido",
  vta_assessments: "Exames VTA",
  water_soil: "Humidade do solo",
  water_stress: "Stress hídrico",
  weather: "Clima",
  weed_removal_root: "Remoção de ervas daninhas da raiz",
  weekly_summary_email: "Resumo semanal por e-mail",
  welcome_back: "Bem-vindo/a de volta!",
  wiki_help: "Wiki e instruções",
  with_sensor: "Com sensor",
  without_location: "Sem localização",
  without_project: "Sem projeto",
  without_sensor: "Sem sensor",
  working: "A funcionar",
  write_some_notes_on_action_performed: "Escrever algumas notas sobre a ação realizada ...",
  write_something: "Escrever algo...",
  years_short: "Anos",
  zip_code: "Código postal",
  zoom_in: "Ampliar",
};
